import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import NewTheme from '../components/admin-dashboard/NewTheme';
import axioInstance from "../components/axiosInstance";
import moment from "moment";
import PlanSyncTable from "../components/zoho/PlanSyncTable";
import PlanActivitySyncTable from "../components/zoho/PlanActivitySyncTable";

export default function ZohoSyncNew() {
    let navigate = useNavigate();

    useEffect(() => {
        const loggedInUser = sessionStorage.getItem("admin_id");
        console.log(loggedInUser);
        if (loggedInUser === null) {
            navigate("/ulogin");
        }
    }, [navigate]);


    // eslint-disable-next-line
    const [createdDate, setCreatedDate] = useState("");
    const [createdDateTo, setCreatedDateTo] = useState("");
    // eslint-disable-next-line
    const [keyEventDate, setKeyEventDate] = useState("");
    const [keyEventDateTo, setKeyEventDateTo] = useState("");

    const [latestRiskDate, setLatestRiskDate] = useState("");
    const [latestRiskDateTo, setLatestRiskDateTo] = useState("");

    // eslint-disable-next-line
    const [profileFrom, setProfileFrom] = useState("");
    // eslint-disable-next-line
    const [profileTo, setProfileTo] = useState("");

    const [loading, setLoading] = useState(false);
    const [activitLoading, setActivityLoading] = useState(false);


    const [data, setData] = useState([]);
    const [activitydata, setActivityData] = useState([]);


    const [planTable, setPlanTable] = useState(false);
    const [planActivityTable, setPlanActivityTable] = useState(false);

    const [planSubmit, setPlanSubmit] = useState(false);
    const [planActivitySubmit, setPlanActivitySubmit] = useState(false);

    const [syncMsg, setSyncMsg] = useState("");
    const [syncMsgError, setSyncMsgError] = useState("");
    const [activitysyncMsgError, setActivitysyncMsgError] = useState("");
    const [activitySyncMsg, setActivitySyncMsg] = useState("");


    const [activityDateFrom, setActivityDateFrom] = useState("");
    // eslint-disable-next-line
    const [activityDateTo, setActivityDateTo] = useState("");
    const [activityProfileFrom, setActivityProfileFrom] = useState("");
    const [activityProfileTo, setActivityProfileTo] = useState("");

    const fetchPlanActivitySync = async (e) => {

        setActivityLoading(true);
        e.preventDefault();

        if (
            (activityDateFrom && activityDateTo) ||
            (activityProfileFrom && activityProfileTo)
        ) {
            try {

                const formData = { plan_activity_from_date: activityDateFrom || '', plan_activity_to_date: activityDateTo, profile_id_from_activity: activityProfileFrom, profile_id_to_activity: activityProfileTo };

                axioInstance.post('/zoho/get-plan-activity-sync-data', formData)
                    .then(response => {

                        setActivityData(response.data.rows || []);
                        setPlanActivitySubmit(true);
                        setActivityDateFrom(activityDateFrom || '');
                        setPlanActivityTable(true);
                    })
                    .catch(error => {
                        setPlanActivitySubmit(false);
                        setPlanActivityTable(false);
                    });
            } catch (error) {
                setPlanActivityTable(false);
                setPlanActivitySubmit(false);
            } finally {
                setActivityLoading(false);
            }
        } else {
            setActivitysyncMsgError("Please provide at least one complete filter criteria.");
            setActivityLoading(false);
            return; // Exit the function early
        }


    };

    const SubmitPlanActivitySync = (e) => {
        setActivityLoading(true);
        e.preventDefault();

        if (
            (activityDateFrom && activityDateTo) ||
            (activityProfileFrom && activityProfileTo)
        ) {
            try {

                const formData = { plan_activity_from_date: activityDateFrom || '', plan_activity_to_date: moment().format("YYYY-MM-DD"), profile_id_from_activity: activityProfileFrom, profile_id_to_activity: activityProfileTo, zohoSync: 'yes' };

                axioInstance.post('/zoho/post-plan-activity-sync-data', formData)
                    .then(response => {

                        setActivityData([]);
                        setPlanActivitySubmit(true);
                        setActivityDateFrom(activityDateFrom || '');
                        setPlanActivityTable(false);
                        setActivitySyncMsg("Total Sync Record: " + response.data.count);
                    })
                    .catch(error => {
                        setPlanActivitySubmit(false);
                        setPlanActivityTable(false);
                    });
            } catch (error) {
                setPlanActivityTable(false);
                setPlanActivitySubmit(false);
            } finally {
                setActivityLoading(false);
            }
        } else {
            setActivitysyncMsgError("Please provide at least one complete filter criteria.");
            setActivityLoading(false);
            return; // Exit the function early
        }

    }

    // eslint-disable-next-line
    const fetchPlanSync = async (e) => {
        setLoading(true);
        e.preventDefault();

        // Validation
        if (
            (createdDate && createdDateTo) ||
            (keyEventDate && keyEventDateTo) ||
            (latestRiskDate && latestRiskDateTo) ||
            (profileFrom && profileTo)
        ) {
            setSyncMsgError("");
            try {

                const formData = { from_date: createdDate, to_date: createdDateTo, profile_id_from: profileFrom, profile_id_to: profileTo, key_event_from_date: keyEventDate, key_event_to_date: keyEventDateTo, latest_risk_from_date: latestRiskDate, latest_risk_to_date: latestRiskDateTo };

                axioInstance.post('/zoho/get-plan-sync-data', formData)
                    .then(response => {

                        setData(response.data.rows || []);
                        setPlanSubmit(true);
                        setPlanTable(true);
                    })
                    .catch(error => {
                        setPlanSubmit(false);
                        setPlanTable(false);
                    });
            } catch (error) {
                setPlanTable(false);
                setPlanSubmit(false);
            } finally {
                setLoading(false);
            }

        } else {
            setSyncMsgError("Please provide at least one complete filter criteria.");
            setLoading(false);
            return; // Exit the function early
        }



    };

    const SubmitPlanSync = (e) => {
        setLoading(true);
        e.preventDefault();
        // Validation
        if (
            (createdDate && createdDateTo) ||
            (keyEventDate && keyEventDateTo) ||
            (latestRiskDate && latestRiskDateTo) ||
            (profileFrom && profileTo)
        ) {
            setSyncMsgError("");

            try {

                const formData = { from_date: createdDate, to_date: createdDateTo, profile_id_from: profileFrom, profile_id_to: profileTo, key_event_from_date: keyEventDate, key_event_to_date: keyEventDateTo, latest_risk_from_date: latestRiskDate, latest_risk_to_date: latestRiskDateTo, zohoSync: 'yes' };

                axioInstance.post('/zoho/post-plan-sync-data', formData)
                    .then(response => {

                        setData([]);
                        setPlanSubmit(true);
                        setPlanTable(false);
                        setSyncMsg("Total Sync Record: " + response.data.count);
                    })
                    .catch(error => {
                        setPlanSubmit(false);
                        setPlanTable(false);
                    });
            } catch (error) {
                setPlanTable(false);
                setPlanSubmit(false);
            } finally {
                setLoading(false);
            }

        } else {
            setSyncMsgError("Please provide at least one complete filter criteria.");
            setLoading(false);
            return; // Exit the function early
        }

    };

    return (
        <>
            <NewTheme loading={loading}>
                <div className="page-header">
                    <div className="content-page-header">
                        <h5>Guest Users Dashboard</h5>
                        <div class="list-btn">
                            <ul class="filter-list">





                                <li>
                                    <a class="btn btn-primary filter-btn" href="zoho-sync" alt="Reset Filters" title="Reset Filters">
                                        <i class="fas fa-sync-alt"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>


                <div className="row">


                    <div className="col-md-12 mb35">
                        <div className="card">
                            <div className="card-header">
                                <div className="row align-center">
                                    <div className="col">
                                        <h5 className="card-title">PLAN Sync</h5>
                                    </div>
                                    <div className="col-auto">
                                        <small>
                                            Webhook :
                                            https://flow.zoho.in/60027533273/flow/webhook/incoming?zapikey=1001.80963bff0fed2bd774f6cad945c2fc40.bfc4687b874b6464da987d59e87724bd&amp;isdebug=false
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12 import_logic" id="import_logic">

                                        <div class="col-md-12 row">
                                            <div class="form-group col-md-2">
                                                <label>Created Date From</label>
                                                <input
                                                    className="form-control"
                                                    type="date"
                                                    name="plan_from_date"
                                                    id="from_date"
                                                    autoComplete="off"
                                                    required="true"
                                                    value={createdDate}
                                                    onChange={(e) => setCreatedDate(e.target.value)}
                                                />
                                            </div>

                                            <div class="form-group col-md-2">
                                                <label>Created Date To</label>
                                                <input
                                                    className="form-control"
                                                    type="date"
                                                    name="plan_to_date"
                                                    id="to_date"
                                                    autoComplete="off"
                                                    required="true"
                                                    value={createdDateTo}
                                                    onChange={(e) => setCreatedDateTo(e.target.value)}
                                                />
                                            </div>
                                        </div>


                                        <span className="ml15">OR</span>
                                        <div class="col-md-12 row">
                                            <div className="form-group  col-md-2 mt-3">
                                                <label>Key Event Date From</label>
                                                <input
                                                    className="form-control"
                                                    type="date"
                                                    name="key_event_from_date"
                                                    id="key_event_from_date"
                                                    autoComplete="off"
                                                    required="true"
                                                    value={keyEventDate}
                                                    onChange={(e) => setKeyEventDate(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group  col-md-2 mt-3">
                                                <label>Key Event Date To</label>
                                                <input
                                                    className="form-control"
                                                    type="date"
                                                    name="key_event_to_date"
                                                    id="key_event_to_date"
                                                    autoComplete="off"
                                                    required="true"
                                                    value={keyEventDateTo}
                                                    onChange={(e) => setKeyEventDateTo(e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <span className="ml15">OR</span>
                                        <div class="col-md-12 row">

                                            <div className="form-group  col-md-2 mt-3">
                                                <label>Latest Risk Date From</label>
                                                <input
                                                    className="form-control"
                                                    type="date"
                                                    name="latest_risk_from_date"
                                                    id="latest_risk_from_date"
                                                    autoComplete="off"
                                                    required="true"
                                                    value={latestRiskDate}
                                                    onChange={(e) => setLatestRiskDate(e.target.value)}
                                                />
                                            </div>

                                            <div className="form-group  col-md-2 mt-3">
                                                <label>Latest Risk Date To</label>
                                                <input
                                                    className="form-control"
                                                    type="date"
                                                    name="latest_risk_to_date"
                                                    id="latest_risk_to_date"
                                                    autoComplete="off"
                                                    required="true"
                                                    value={latestRiskDateTo}
                                                    onChange={(e) => setLatestRiskDateTo(e.target.value)}
                                                />
                                            </div>

                                        </div>

                                        <span className="ml15">OR</span>
                                        <div className="form-group  col-md-3 mt-3">
                                            <label htmlFor="inputGroup">Profile ID Range</label>
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control mr10"
                                                    id="profile_id_from"
                                                    name="profile_id_from"
                                                    placeholder="From"
                                                    value={profileFrom}
                                                    onChange={(e) => setProfileFrom(e.target.value)}
                                                />
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="profile_id_to"
                                                    name="profile_id_to"
                                                    placeholder="To"
                                                    value={profileTo}
                                                    onChange={(e) => setProfileTo(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div id="plan_res_success">
                                            {syncMsg && <p>{syncMsg}</p>}
                                            {syncMsgError && <strong className='text-danger ml15'>{syncMsgError}</strong>}
                                            {planTable && <PlanSyncTable data={data} />}

                                        </div>
                                        <div className="form-group mt-4 mb-0 ml15">

                                            <button
                                                type="button"
                                                className="btn btn-primary mr-3"
                                                onClick={(e) => fetchPlanSync(e)}
                                                id="plan_profile_fetch_btn"
                                                disabled={loading}
                                            >
                                                {loading ? (
                                                    <>
                                                        <span
                                                            className="spinner-border spinner-border-sm me-2"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                        Fetching Plan Data...
                                                    </>
                                                ) : (
                                                    "Fetch Plan Data"
                                                )}
                                            </button>
                                            {(planSubmit && data.length > 0) && <button
                                                type="button"
                                                className="btn btn-info text-white"
                                                id="plan_profile_submit_btn"
                                                style={{}}
                                                onClick={(e) => SubmitPlanSync(e)}
                                            >
                                                {loading ? (
                                                    <>
                                                        <span
                                                            className="spinner-border spinner-border-sm me-2"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                        Sending Plan Data...
                                                    </>
                                                ) : (
                                                    "Submit Plan Data Sync"
                                                )}
                                            </button>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <br /> <br /> <br />

                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row align-center">
                                    <div className="col">
                                        <h5 className="card-title">PLAN Activity Sync</h5>
                                    </div>
                                    <div className="col-auto">
                                        <small>
                                            Webhook :
                                            https://flow.zoho.in/60027533273/flow/webhook/incoming?zapikey=1001.31dffc221bd95111261c940fb8cdbc72.31b23750e01f79e67ef840cc351eb9b1&amp;isdebug=false
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12 import_logic" id="import_logic">
                                        <div className="col-md-12 row">
                                            <div className="form-group col-md-2">
                                                <label>Activity Date</label>
                                                <input
                                                    className="form-control"
                                                    type="date"
                                                    name="plan_activity_from_date"
                                                    id="plan_activity_from_date"
                                                    autoComplete="off"
                                                    required="true"
                                                    value={activityDateFrom}
                                                    onChange={(e) => setActivityDateFrom(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group col-md-2">
                                                <label title="ETClient_L3import.modified">
                                                    Activity To Date
                                                </label>
                                                <input
                                                    className="form-control"
                                                    type="date"
                                                    name="plan_activity_to_date"
                                                    id="plan_activity_to_date"
                                                    autoComplete="off"
                                                    required="true"
                                                    value={activityDateTo}
                                                    onChange={(e) => setActivityDateTo(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <span className="ml15">OR</span>
                                        <div className="form-group  col-md-3 mt-3">
                                            <label htmlFor="inputGroup">Profile ID Range</label>
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control mr10"
                                                    id="profile_id_from_activity"
                                                    name="profile_id_from_activity"
                                                    placeholder="From"
                                                    value={activityProfileFrom}
                                                    onChange={(e) => setActivityProfileFrom(e.target.value)}
                                                />
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="profile_id_to_activity"
                                                    name="profile_id_to_activity"
                                                    placeholder="To"
                                                    value={activityProfileTo}
                                                    onChange={(e) => setActivityProfileTo(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div id="plan_activity_res_success">

                                            {activitySyncMsg && <p>{activitySyncMsg}</p>}
                                            {activitysyncMsgError && <strong className='text-danger ml15'>{activitysyncMsgError}</strong>}
                                            {planActivityTable && <PlanActivitySyncTable activitydata={activitydata} />}
                                        </div>
                                        <div className="form-group mt-4 mb-0 ml15">
                                                

                                            <button
                                                type="button"
                                                className="btn btn-primary mr-3"
                                                onClick={(e) => fetchPlanActivitySync(e)}
                                                disabled={activitLoading}
                                                id="plan_profile_activity_fetch_btn"
                                            >
                                                {activitLoading ? (
                                                    <>
                                                        <span
                                                            className="spinner-border spinner-border-sm me-2"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                        Fetching Plan Activity Data...
                                                    </>
                                                ) : (
                                                    "Fetch Plan Activity Data"
                                                )}
                                            </button>


                                            {(planActivitySubmit && activitydata.length > 0) && <button
                                                type="button"
                                                className="btn btn-info text-white"
                                                id="plan_profile_activity_submit_btn"
                                                style={{}}
                                                onClick={(e) => SubmitPlanActivitySync(e)}
                                            >
                                                {activitLoading ? (
                                                    <>
                                                        <span
                                                            className="spinner-border spinner-border-sm me-2"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                        Submiting Plan Activity Sync Data...
                                                    </>
                                                ) : (
                                                    "Submit Plan Activity Sync"
                                                )}
                                            </button>}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>




                </div>


            </NewTheme>
        </>
    );
}